<template>
  <div class="page-container">
    <div v-if="!appStore.hasEb100C" class="page-container">
      <!-- 顶部搜索栏 -->
      <div class="top-container">
        <el-form class="power-form" inline :model="powerForm" :ref="powerRef">
          <div class="form-left-items">
            <el-form-item :label="$str.getKey('数据分析/日期')">
              <el-date-picker v-model="powerForm.timer" @change="timeRangeChange" :disabled-date="disabledDate"
                :range-separator="$str.getKey('数据分析/至')" :clearable="false" type="daterange" format="YYYY-MM-DD"
                size="default" class="filter-date-picker"></el-date-picker>
            </el-form-item>
            <el-form-item :label="$str.getKey('数据分析/选择方阵')">
              <div class="select-container">
                <el-radio-group v-model="powerForm.selectType" @change="selectTypeChanged" size="default">
                  <el-radio label="station">{{ $str.getKey('数据分析/整站') }}</el-radio>
                  <el-radio v-if="appStore.hasEb100C" label="elink">group</el-radio>
                  <el-radio v-else label="eLink">{{ $str.getKey('数据分析/eLink') }}</el-radio>
                  <el-radio label="eBlock">{{ $str.getKey('数据分析/eBlock') }}</el-radio>
                </el-radio-group>
                <el-cascader v-if="powerForm.selectType != 'station'" class="cascader-select"
                  v-model="powerForm.selectedDevice" :options="powerForm.selectOptions" :show-all-levels="false"
                  size="default" @change="selectDeviceChanged" />
              </div>
            </el-form-item>
          </div>
        </el-form>
        <el-form-item>
          <div class="filter-actions">
            <v-btn color="#2655f1" rounded="xl" class="action-btn" @click="onSearch">
              <v-icon start icon="mdi-magnify" />{{ $str.getKey('数据分析/查询') }}
            </v-btn>
            <v-btn variant="outlined" color="#2655f1" rounded="xl" class="action-btn" @click="onExport">
              <v-icon start icon="mdi-download" />{{ $str.getKey('数据分析/导出') }}
            </v-btn>
            <v-btn variant="outlined" color="#2655f1" rounded="xl" class="action-btn" @click="onReset">
              <v-icon start icon="mdi-refresh" />{{ $str.getKey('数据分析/重置') }}
            </v-btn>
          </div>
        </el-form-item>
      </div>
      <!-- 图表区域 -->
      <div class="main-container">
        <div class="chart-title">{{ $str.getKey('数据分析/储能单元SOC-功率跟踪分析曲线') }}</div>
        <div ref="linesChartDom" class="chart-container"></div>
        <!-- 加载状态 -->
        <div v-if="chartLoading" class="chart-status">
          <div class="status-content">
            <span class="loading-text">{{ $str.getKey('数据分析/加载中...') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, nextTick, onMounted } from "vue";
import * as echarts from 'echarts';
import dayjs from "dayjs";
import { useAppStore } from "@/store/modules/app";
import { PowerTrackingData } from "./index.js"
import { ElMessageBox } from "element-plus";
import { cloneDeep } from "@/utils"

const $str = window.$str;

/** 获取stationId，并监听其变化-更新数据 */
const appStore = useAppStore();
const { stationId } = appStore.useStationState({
  stationIdWatch() {
    stationIdChangeCb(stationId.value);
  }
});

/** 获取strategySwitch >>> 处理图表中是否展示【虚拟电厂调度功率】的业务逻辑 >>> 待处理 */
/** strategySwitch：影响获取的策略类型 >>> 开关值来自：eCloud/电站管理/电站-基本参数/【策略控制：开关】 */
const strategySwitch = computed(() => { return appStore.strategySwitch; });

/** 获取meterModel >>> 判断是实体表还是虚拟表：0-虚拟表，1-实体表 */
const meterModel = computed(() => {
  return appStore.getMeterModel(stationId.value);
});


/** 查询表单-业务相关变量的定义 ====== */
const powerRef = ref(null);
const originPowerForm = {
  timer: [dayjs(), dayjs()],
  // timer: [dayjs('2025-04-19'), dayjs('2025-04-19')],
  selectType: 'station', // 'eLink' | 'eBlock'
  selectOptions: [
    // {
    //   value: '1#eLink',
    //   label: '1#eLink',
    //   children: [
    //     {
    //       value: '1#eBlock',
    //       label: '1#eBlock',
    //       children: [],
    //     },
    //     {
    //       value: '2#eBlock',
    //       label: '2#eBlock',
    //       children: [],
    //     },
    //     {
    //       value: '3#eBlock',
    //       label: '3#eBlock',
    //       children: [],
    //     },
    //   ]
    // },
    // {
    //   value: '2#eLink',
    //   label: '2#eLink',
    //   children: [
    //     {
    //       value: '1#eBlock',
    //       label: '1#eBlock',
    //       children: [],
    //     },
    //     {
    //       value: '2#eBlock',
    //       label: '2#eBlock',
    //       children: [],
    //     },
    //     {
    //       value: '3#eBlock',
    //       label: '3#eBlock',
    //       children: [],
    //     },
    //   ],
    // },
    // {
    //   value: '3#eLink',
    //   label: '3#eLink',
    //   children: [],
    // },
  ],
  selectedDevice: [],
}
const powerForm = reactive(cloneDeep(originPowerForm));

/** 初始化一个辅助类，处理数据获取&图表渲染相关的的各种业务逻辑 ====== */
const powerTrackingOptions = {
  strategySwitch: strategySwitch.value,
  startTime: dayjs(powerForm.timer[0]).format("YYYY-MM-DD ") + "00:00:00",
  endTime: dayjs(powerForm.timer[1]).format("YYYY-MM-DD ") + "23:59:59",
  selectType: powerForm.selectType,
  meterModel: meterModel.value,
}
const powerTracking = new PowerTrackingData(stationId.value, powerTrackingOptions);




/** 图表-业务相关变量的定义 ====== */
const linesChartDom = ref(null); // 引用echar-dom
let linesChartObj = null; // 引用echarts实例对象
const chartLoading = ref(false); // 图表加载状态
const chartEmpty = ref(false); // 图表是否为空数据

onMounted(() => {
  /** 初始化图表，执行图表渲染 */
  if (linesChartDom.value) {
    linesChartObj = echarts.init(linesChartDom.value);
  }

  // initPageByStation(stationId.value); // 在获取stationId时，已经执行过了
  // powerTracking.listenChartsLegendChange(linesChartObj)
})

/**
 * 基于电站ID初始化页面
 * @param {*} id stationId
 */
function initPageByStation(id) {
  const opfData = cloneDeep(originPowerForm);
  powerForm.timer = opfData.timer;
  powerForm.selectType = opfData.selectType;
  powerForm.selectOptions = opfData.selectOptions;
  powerForm.selectedDevice = opfData.selectedDevice;
  powerTracking.updateTimeRange(...powerForm.timer);
  powerTracking.updateSelectType(powerForm.selectType);
  powerTracking.updateSelectedDevice(...powerForm.selectedDevice);
  powerTracking.updateMeterModel(meterModel.value);
  chartLoading.value = true;
  chartEmpty.value = false;
  powerTracking.updateStationId(id).then(() => {
    // 更新【eLink|eBlock】下拉选项数据
    updateSelectOptionsForForm();
    // 初始化图表 - 使用nextTick确保DOM已渲染
    nextTick(() => {
      const timerId = setInterval(() => {
        if (linesChartObj && timerId) {
          clearInterval(timerId);
          powerTracking.initCharts(linesChartObj).then(() => {
            checkChartData();
          }).catch(() => {
            chartLoading.value = false;
            chartEmpty.value = true;
          }).finally(() => {
            // 确保图表尺寸正确
            if (linesChartObj && typeof linesChartObj.resize === 'function') {
              setTimeout(() => {
                linesChartObj.resize();
              }, 100);
            }
          });
        }
      }, 100);
    });
  });
}


/**
 * stationId 发生变化的回调。【获取 stationId 时会立即执行一次】【优先级最高】
 * 1、初始化页面相关的变量
 * 2、更新所有相关数据的获取
 * 3、刷新图表的渲染
 * @param {*} id stationId
 */
function stationIdChangeCb(id) {
  initPageByStation(id);
}

/** 时间范围发生变化 */
function timeRangeChange() {
  if (powerForm.timer && powerForm.timer.length === 2) {
    // 确保日期格式正确，转换为 dayjs 对象用于后续处理
    const start = dayjs(powerForm.timer[0]);
    const end = dayjs(powerForm.timer[1]);
    powerForm.timer = [start, end];
    if (checkDateRange()) {
      onSearch();
    }
  }
}

/** 检查选择的日期范围是否正确 */
function checkDateRange(range = 1) {
  const st = dayjs(powerForm.timer[0]);
  const et = dayjs(powerForm.timer[1]);
  const limitDay = st.add(range, 'month');
  if (et >= limitDay) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('数据分析/日期范围过大，请选择范围为1个月内的日期')
    })
    return false;
  }
  return true;
}

/** 选择方阵的选项发生变化 */
function selectTypeChanged() {
  powerForm.selectedDevice = [];
  updateSelectOptionsForForm();
  if (powerForm.selectType == 'station') {
    onSearch();
  }
  if (powerForm.selectType == 'eLink') {
    // 默认选择第一个eLink并更新图表
    if (powerForm.selectOptions.length > 0) {
      powerForm.selectedDevice = [powerForm.selectOptions[0].value];
      onSearch();
    }
  }
  if (powerForm.selectType == 'eBlock') {
    // 默认选择【第一个eLink】的【第一个eBlock】并更新图表
    if (powerForm.selectOptions[0]?.children?.length > 0) {
      powerForm.selectedDevice = [powerForm.selectOptions[0].value, powerForm.selectOptions[0].children[0].value];
      onSearch();
    }
  }
}

/** eLink|eBlock选中项发生变化 */
function selectDeviceChanged() {
  onSearch();
}

/** 搜索 */
function onSearch() {
  // 校验日期
  if (!powerForm.timer || powerForm.timer.length !== 2) {
    window.dispatchNotify({
      type: 'warning',
      message: $str.getKey('数据分析/请选择日期范围')
    });
    return false;
  }

  // 校验
  const len = powerForm.selectedDevice.length;
  if (powerForm.selectType == 'eLink' && len < 1) {
    window.dispatchNotify({
      type: 'warning',
      message: $str.getKey('数据分析/请选择eLink')
    })
    return false;
  }
  if (powerForm.selectType == 'eBlock' && len < 2) {
    window.dispatchNotify({
      type: 'warning',
      message: $str.getKey('数据分析/请选择eBlock')
    })
    return false;
  }
  if (!checkDateRange()) {
    return false;
  }
  // 更新图表受控参数
  powerTracking.updateTimeRange(...powerForm.timer);
  powerTracking.updateSelectType(powerForm.selectType);
  powerTracking.updateSelectedDevice(...powerForm.selectedDevice);
  powerTracking.updateMeterModel(meterModel.value);

  // 更新图表
  chartLoading.value = true;
  chartEmpty.value = false;
  powerTracking.updateCharts(linesChartObj).then(() => {
    checkChartData();
  }).catch(() => {
    chartLoading.value = false;
    chartEmpty.value = true;
  }).finally(() => {
    // 确保图表尺寸正确
    if (linesChartObj && typeof linesChartObj.resize === 'function') {
      setTimeout(() => {
        linesChartObj.resize();
      }, 100);
    }
  });

}

/** 导出 */
function onExport() {
  // 校验日期
  if (!powerForm.timer || powerForm.timer.length !== 2) {
    window.dispatchNotify({
      type: 'warning',
      message: $str.getKey('数据分析/请先选择日期范围')
    });
    return;
  }

  ElMessageBox.confirm(
    $str.getKey('数据分析/是否确认导出功率跟踪数据？'),
    $str.getKey('数据分析/提示'),
    {
      confirmButtonText: $str.getKey('数据分析/确定'),
      cancelButtonText: $str.getKey('数据分析/取消'),
      type: "warning",
      confirmButtonClass: 'custom-confirm-btn',
      cancelButtonClass: 'custom-cancel-btn',
    }
  ).then(() => {
    const st = dayjs(powerForm.timer[0]).format("YYYY-MM-DD ") + "00:00:00";
    const et = dayjs(powerForm.timer[1]).format("YYYY-MM-DD ") + "23:59:59";
    const selectType = powerForm.selectType;
    const len = powerForm.selectedDevice.length;
    const eLinkId = len > 0 ? powerForm.selectedDevice[0] : undefined;
    const eBlockId = len > 1 ? powerForm.selectedDevice[1] : undefined;
    powerTracking.exportPowerTrackingData(st, et, selectType, eLinkId, eBlockId);
  }).catch(() => { });
}


/** 重置 */
function onReset() {
  const opfData = cloneDeep(originPowerForm);
  powerForm.timer = opfData.timer;
  powerForm.selectType = opfData.selectType;
  powerForm.selectOptions = opfData.selectOptions;
  powerForm.selectedDevice = opfData.selectedDevice;
  powerTracking.updateTimeRange(...powerForm.timer);
  powerTracking.updateSelectType(powerForm.selectType);
  powerTracking.updateSelectedDevice(...powerForm.selectedDevice);
  powerTracking.updateMeterModel(meterModel.value);
  updateSelectOptionsForForm();
  chartLoading.value = true;
  chartEmpty.value = false;
  powerTracking.initCharts(linesChartObj).then(() => {
    checkChartData();
  }).catch(() => {
    chartLoading.value = false;
    chartEmpty.value = true;
  }).finally(() => {
    // 确保图表尺寸正确
    if (linesChartObj && typeof linesChartObj.resize === 'function') {
      setTimeout(() => {
        linesChartObj.resize();
      }, 100);
    }
  });
}

/** 检查图表数据是否为空 */
function checkChartData() {
  chartLoading.value = false;
  const chartData = powerTracking.chartData;
  // 检查是否有数据：包括曲线数据和需量保护阈值
  // 需量保护阈值即使为0也算有数据（因为图表会显示这条线）
  const hasData =
    (chartData.socChartData && chartData.socChartData.length > 0) ||
    (chartData.powerChartData && chartData.powerChartData.length > 0) ||
    (chartData.strategyChartData && chartData.strategyChartData.length > 0) ||
    (chartData.thirdPowerChartData && chartData.thirdPowerChartData.length > 0) ||
    (chartData.historyTimePointsChartData && chartData.historyTimePointsChartData.length > 0) ||
    (chartData.demand !== undefined && chartData.demand !== null); // 需量保护阈值

  chartEmpty.value = !hasData;

  // 如果无数据，清空图表
  if (!hasData && linesChartObj) {
    linesChartObj.clear();
  }
}

/** 监听浏览器尺寸变化，重置图表尺寸 */
window.addEventListener('resize', () => {
  if (linesChartObj) {
    linesChartObj.resize();
  }
})

/** ====== 功能辅助方法 ================================================================================ */
/** 更新表单中eLink & eBlock的可选项 */
function updateSelectOptionsForForm() {
  if (powerForm.selectType == 'station') {
    powerForm.selectOptions = [];
  } else {
    powerForm.selectOptions = powerTracking.eLinkList.map(it => {
      const eLink = {
        value: it.uuid,
        label: it.equipmentName,
        children: [],
      }

      if (powerForm.selectType == 'eBlock' && it.list && Array.isArray(it.list)) {
        eLink.children = it.list.map(eBlock => {
          return {
            label: eBlock.equipmentName,
            value: eBlock.uuid
          }
        })
      }
      return eLink;
    })
  }

}

/** 设置日期的禁选范围 */
function disabledDate(date) {
  const latestHalfYear = dayjs().subtract(6, 'month');
  return dayjs(date) > dayjs() || dayjs(date) < latestHalfYear;
}




</script>

<style lang="scss" scoped>
.page-container {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  .top-container {
    height: auto;
    padding: 0 24px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;

    .form-left-items {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap;
    }

    .power-form {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
    }

    .el-form-item {
      margin-bottom: 0;
      margin-right: 0;
      display: flex;
      align-items: center;
      height: 40px;

      :deep(.el-form-item__label) {
        font-size: 14px;
        color: rgba(46, 46, 46, 0.85);
        font-weight: 400;
        padding-right: 12px;
        line-height: 40px;
        height: 40px;
        display: flex;
        align-items: center;
      }

      :deep(.el-form-item__content) {

        line-height: 40px;
        display: flex;
        align-items: center;

        .el-range-editor {
          width: 260px !important;
          min-width: 260px !important;
          max-width: 260px !important;
        }
      }
    }

    .filter-date-picker {

      :deep(.el-input__wrapper) {
        width: 100% !important;
        max-width: 100% !important;
        background: #fff;
        border: 1px solid rgba(192, 207, 218, 0.3);
        border-radius: 20px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        padding: 0 16px;
        min-height: 40px;
        height: 40px;
        transition: border-color 0.2s;

        &.is-focus {
          border-color: #3a68ff;
        }
      }

      :deep(.el-input__inner) {
        font-family: "HarmonyOS Sans SC", sans-serif;
        font-size: 14px;
        color: #2E2E2E;
        height: 40px;
        line-height: 40px;

        &::placeholder {
          color: rgba(46, 46, 46, 0.5);
          font-weight: 400;
          font-family: "HarmonyOS Sans SC", sans-serif;
        }
      }

      :deep(.el-input__suffix) {
        color: rgba(46, 46, 46, 0.5);
      }

      :deep(.el-range-input) {
        font-family: "HarmonyOS Sans SC", sans-serif;
        font-size: 14px;
        color: #2E2E2E;
      }

      :deep(.el-range-separator) {
        font-family: "HarmonyOS Sans SC", sans-serif;
        font-size: 14px;
        color: #2E2E2E;
      }
    }

    .select-container {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap;

      .el-radio-group {
        display: flex;
        gap: 16px;
        flex-wrap: wrap;

        :deep(.el-radio) {
          font-size: 14px;
          color: rgba(46, 46, 46, 0.85);
          font-weight: 400;

          .el-radio__label {
            font-size: 14px;
            color: rgba(46, 46, 46, 0.85);
            padding-left: 8px;
          }

          &.is-checked {
            .el-radio__label {
              color: #306BF4;
              font-weight: 400;
            }

            .el-radio__inner {
              border-color: #306BF4;
              background-color: #306BF4;

              &::after {
                background-color: #fff;
              }
            }
          }
        }
      }

      .cascader-select {
        width: 200px;

        :deep(.el-input__inner) {
          font-size: 14px;
          color: rgba(46, 46, 46, 0.85);
          height: 32px;
          line-height: 32px;
        }
      }
    }


    .filter-actions {
      display: flex;
      align-items: center;
      gap: 12px;
      flex-shrink: 0;
      height: 40px;
    }
  }

  .main-container {
    flex: 1;
    width: 100%;
    padding: 20px;
    background: rgba(255, 255, 255, 1);
    border-radius: 0 0 20px 20px;
    display: flex;
    flex-direction: column;
    min-height: 0;
    position: relative;

    .chart-title {
      font-family: 'HarmonyOS Sans SC', sans-serif;
      font-size: 16px;
      color: rgba(46, 46, 46, 1);
      font-weight: 500;
      margin-bottom: 0;
    }

    .chart-container {
      flex: 1;
      width: 100%;
      min-height: 0;
    }

    .chart-status {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.9);
      z-index: 10;

      .status-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;

        .loading-text,
        .empty-text {
          font-family: "HarmonyOS Sans SC", sans-serif;
          font-size: 14px;
          color: rgba(46, 46, 46, 0.65);
          font-weight: 400;
        }
      }
    }
  }

  // 设置图表tooltip的样式
  ::v-deep .chart-tooltip {
    padding: 12px 16px !important;
    border-radius: 8px !important;
    background: rgba(255, 255, 255, 0.90) !important;
    backdrop-filter: blur(4px);
    border: none !important;
  }

  ::v-deep .chart-tooltip__time {
    margin-bottom: 8px;
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #6A727C;
  }

  ::v-deep .chart-tooltip__items-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  ::v-deep .chart-tooltip__series {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 4px 8px;
    border-radius: 6px;
  }

  ::v-deep .chart-tooltip__series-name,
  ::v-deep .chart-tooltip__value {
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    margin-left: 4px;
    color: var(--text-icon-font-gy-190-primary, rgba(0, 0, 0, 0.90));
  }

  ::v-deep .chart-tooltip__point {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 4px;
    flex-shrink: 0;
  }
}

.el-date-editor {
  .el-range__close-icon {
    display: none !important;
  }
}

// 选中日期时的颜色
.el-date-editor.el-input__wrapper:hover {
  box-shadow: none !important;
}
</style>

<style lang="scss">
// 全局样式：ElMessageBox 挂载在 body 上，需要全局样式才能生效
.el-message-box {
  .custom-confirm-btn {
    font-family: "HarmonyOS Sans SC", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    background: #3a68ff !important;
    color: #fff !important;
    border: none !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: all 0.2s;
    box-sizing: border-box !important;

    span {
      padding: 8px 15px !important;
    }

    &:hover {
      background: #3a68ff !important;
      opacity: 0.9;
    }

    &:active {
      background: #3a68ff !important;
      opacity: 0.8;
    }
  }

  .custom-cancel-btn {
    padding: 8px 15px !important;
    font-family: "HarmonyOS Sans SC", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    border: 1px solid rgba(192, 207, 218, 0.3) !important;
    color: #2e2e2e !important;
    background: #fff !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: all 0.2s;
    box-sizing: border-box !important;

    span {
      padding: 8px 15px !important;
    }

    &:hover {
      background: #f5f7fa !important;
      color: #2e2e2e !important;
    }

    &:active {
      background: #f5f7fa !important;
    }
  }
}
</style>
